module.exports = __webpack_public_path__ + "img/tenant-feature-configuration.808b9210.svg";